import React from 'react';
import { PipelineStatus } from '../../../const/PipelineTypes';
import { getStatusColor } from '../PipelineTableFunctionality';

interface StageToolTipIconProps {
  status: PipelineStatus;
  size?: number;
  marginBottom?: number;
  theme: boolean;
}

const StageToolTipIcon: React.FC<StageToolTipIconProps> = ({ status, size = 14, marginBottom = 5, theme }) => {
  const baseStyle = {
    width: size,
    height: size,
    display: 'inline-block' as const,
    verticalAlign: 'middle' as const,
    marginBottom: `${marginBottom}px`
  };
  const iconStyle = { fontSize: size, verticalAlign: 'middle' as const, marginBottom: `${marginBottom}px` };

  switch (status) {
    case PipelineStatus.InProgress:
      return <span className="wf-icon-running-tooltip" style={baseStyle} />;
    case PipelineStatus.Completed:
    case PipelineStatus.Success:
      return <span className="wf-icon-success-tooltip" style={baseStyle} />;
    case PipelineStatus.Failure:
      return <span className="wf-icon-failed-tooltip" style={baseStyle} />;
    case PipelineStatus.Canceled:
      return <i className="icon icon-block" style={iconStyle} />;
    case PipelineStatus.Pending:
      return <span className="wf-icon-notstarted-tooltip" style={baseStyle} />;
    case PipelineStatus.Banned:
      return <i className="icon icon-block" style={iconStyle} />;
    case PipelineStatus.Manual: {
      let bottM = 5.5;
      if (size === 16) bottM = 4;
      if (size === 14) bottM = 4.5;
      return (
        <span className="round" style={{ minWidth: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-info" style={{ fontSize: size - 4, position: 'relative', left: 2, bottom: bottM }} />
        </span>
      );
    }
    case PipelineStatus.Warning: {
      let bottW = 6;
      if (size === 16) bottW = 4;
      if (size === 14) bottW = 5;
      return (
        <span className="round" style={{ minWidth: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-triangle-warning" style={{ fontSize: size - 6, position: 'relative', left: 3, bottom: bottW }} />
        </span>
      );
    }
    case PipelineStatus.Aborted: {
      let bottW = 6;
      if (size === 16) bottW = 4;
      if (size === 14) bottW = 5;
      return (
        <span className="round" style={{ minWidth: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-minus-small" style={{ fontSize: size - 6, position: 'relative', left: 3, bottom: bottW }} />
        </span>
      );
    }
    case PipelineStatus.Paused: {
      let bottW = 6;
      if (size === 16) bottW = 4;
      if (size === 14) bottW = 5;
      return (
        <span className="round" style={{ minWidth: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-video-pause" style={{ fontSize: size - 6, position: 'relative', left: 3, bottom: bottW }} />
        </span>
      );
    }
    default:
      return null;
  }
};

export default StageToolTipIcon;
